export const partnerBaseTypeDef = `
  id
  name
`;

export const partnerTypeDef = `
  ${partnerBaseTypeDef}
  partnerFiles {
    id
    kind
    src
  }
`;
